import { DeliveryAddressCard } from "./DeliveryAddressCard";
import { DeliveryAddress } from "@/services/settings/settingsService";

interface AddressListProps {
  addresses: DeliveryAddress[];
  onSetDefault: (id: string) => void;
  onDelete?: (id: string) => void;
  onEdit?: (id: string) => void;
}

export const AddressList = ({ addresses, onSetDefault, onDelete, onEdit }: AddressListProps) => {
  const canDelete = addresses.length > 1;
  
  return (
    <div className="space-y-4">
      {addresses.map((address) => (
        <DeliveryAddressCard
          key={address.id}
          address={address}
          onSetDefault={onSetDefault}
          onDelete={onDelete}
          onEdit={onEdit}
          canDelete={canDelete}
        />
      ))}
    </div>
  );
};